export { revalidateCommunity } from 'next-flight-server-reference-proxy-loader?id=40521c97e34301c085ab755d0c2594472e9a2b1411&name=revalidateCommunity!'